import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { ownsCrmSuiteProductLevel } from '../../../../selectors/ProductInventorySelectors';
import { useQueryParamTerm } from '../../../../utils/urls/appQueryParamUtils';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import SuiteTermSelectorContainer from '../../SuiteTermSelectorContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteCardTerm = ({
  productLevel,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  const ownsProductVersion = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel
  }));
  const {
    setQueryParamTerm,
    queryParamTerm
  } = useQueryParamTerm();
  if (ownsProductVersion) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [41],
    widths: ['100%'],
    children: /*#__PURE__*/_jsx(SuiteTermSelectorContainer, {
      productLevel: productLevel,
      onChange: setQueryParamTerm,
      queryParamTerm: queryParamTerm,
      trackingSource: trackingSource
    })
  });
};